export const MAX_RELOADS = 2;
